import { render, staticRenderFns } from "./HubIaMigrationDialog.vue?vue&type=template&id=090ccb6a&scoped=true"
import script from "./HubIaMigrationDialog.vue?vue&type=script&lang=js"
export * from "./HubIaMigrationDialog.vue?vue&type=script&lang=js"
import style0 from "./HubIaMigrationDialog.vue?vue&type=style&index=0&id=090ccb6a&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090ccb6a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('090ccb6a')) {
      api.createRecord('090ccb6a', component.options)
    } else {
      api.reload('090ccb6a', component.options)
    }
    module.hot.accept("./HubIaMigrationDialog.vue?vue&type=template&id=090ccb6a&scoped=true", function () {
      api.rerender('090ccb6a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/apps/chatbots/components/HubIaMigrationDialog.vue"
export default component.exports